module.exports = __webpack_public_path__ + "static/media/crm.b8fd3d1f.gif";